{
  "titulo": "Auditoría",
  "entidades": {
    "empresa": "Empresa",
    "sucursal": "Sucursal",
    "deposito": "Depósito",
    "puesto_de_caja": "Puesto de caja",
    "punto_de_venta": "Punto de venta",
    "parametro": "Configuración",
    "rol": "Rol",
    "membresia": "Persona",
    "invitacion": "Invitación",
    "sesion": "Sesión"
  },
  "acciones": {
    "alta": "Alta",
    "modificacion": "Modificación",
    "baja": "Baja",
    "cambio_de_empresa": "Cambio de empresa",
    "invitacion_aceptada": "Invitación aceptada"
  },
  "columnas": {
    "momento": "Cuándo",
    "quien": "Quién",
    "que": "Qué",
    "accion": "Acción",
    "desde": "Desde",
    "detalle": "Detalle"
  },
  "detalle": {
    "antes": "Antes",
    "despues": "Después",
    "sinCambios": "Sin datos registrados"
  },
  "filtros": {
    "todas": "Todas",
    "desdeFecha": "Desde",
    "hastaFecha": "Hasta"
  },
  "masResultados": "Ver más",
  "descripcion": "Quién hizo qué, cuándo y desde dónde."
}
